import { BigNumber } from "ethers";
import useAssets from "hooks/useAssets";
import useVesting from "hooks/useVesting";
import { useMemo } from "react";

const useHoneyInBears = (): Record<number, BigNumber> | undefined => {
  const { fancyBearsInWallet } = useAssets();
  const { vestingAmountInBearsRemaining } = useVesting();

  return useMemo(() => {
    if (fancyBearsInWallet && vestingAmountInBearsRemaining) {
      return fancyBearsInWallet.reduce(
        (prev, tokenId, index) => ({
          ...prev,
          [tokenId]: vestingAmountInBearsRemaining[index],
        }),
        {}
      );
    }
  }, [fancyBearsInWallet, vestingAmountInBearsRemaining]);
};

export default useHoneyInBears;
